(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    /* Toggle buttons */
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    /* Close button */
    document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    /* Overlay click */
    overlay.addEventListener('click', closeDrawer);

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    /* Quantity +/- in drawer */
    drawer.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-drawer-qty-minus]');
      var plus = e.target.closest('[data-drawer-qty-plus]');
      var remove = e.target.closest('[data-drawer-remove]');

      if (remove) {
        e.preventDefault();
        var removeLine = parseInt(remove.getAttribute('data-line'), 10);
        updateCartLine(removeLine, 0);
        return;
      }

      if (!minus && !plus) return;

      var line = parseInt((minus || plus).getAttribute('data-line'), 10);
      var display = drawer.querySelector('[data-drawer-qty-value][data-line="' + line + '"]');
      if (!display) return;

      var current = parseInt(display.textContent, 10) || 1;
      var newVal = minus ? Math.max(0, current - 1) : current + 1;
      display.textContent = newVal;

      updateCartLine(line, newVal);
    });

    function updateCartLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          refreshDrawer(cart);
          updateHeaderCount(cart.item_count);
        });
    }

    function refreshDrawer(cart) {
      /* Re-fetch the page fragment to update drawer HTML */
      fetch(window.location.pathname + '?sections=cart-drawer-content')
        .then(function () {
          /* Simple approach: reload the page to refresh server-rendered drawer */
          window.location.reload();
        });
    }

    function updateHeaderCount(count) {
      var badge = document.querySelector('.header__cart-count');
      if (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      }
    }

    /* AJAX add-to-cart: intercept product forms */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          /* Reload to update server-rendered drawer contents, then open */
          /* Store flag so drawer opens after reload */
          try { sessionStorage.setItem('open_cart_drawer', '1'); } catch (err) { /* noop */ }
          window.location.reload();
        });
    });

    /* Check if we should open drawer after reload (AJAX add-to-cart) */
    try {
      if (sessionStorage.getItem('open_cart_drawer') === '1') {
        sessionStorage.removeItem('open_cart_drawer');
        openDrawer();
      }
    } catch (err) { /* noop */ }
  })();
  } catch(e) { console.error(e); }
})();

})();
